<template>
  <div>MyOrders</div>
</template>

<script>
export default {
  name: "MyOrders"
}
</script>

<style scoped>

</style>